import { render, staticRenderFns } from "./TestimonialCarousel.vue?vue&type=template&id=4d6e8564&scoped=true&"
import script from "./TestimonialCarousel.vue?vue&type=script&lang=ts&"
export * from "./TestimonialCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./TestimonialCarousel.vue?vue&type=style&index=0&id=4d6e8564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6e8564",
  null
  
)

export default component.exports